module.exports = __webpack_public_path__ + "static/media/game(4).839a88c5.PNG";